import { useMemo } from 'react'
import { ShieldCheck } from 'lucide-react'
import { IssueTable, TableSkeleton } from '@/components/tables/issue-table'
import { ViewHeader } from '@/components/shell/view-header'
import { useViewFilters } from '@/hooks/use-view-filters'
import { useIssues } from '@/lib/query'
import { useMe } from '@/hooks/use-me'
import { MY_VERIFICATIONS_VIEW } from '@/lib/views'
import { ViewError } from '@/components/common/query-states'
import { EmptyState } from '@/components/common/empty-state'

export default function MyVerifications() {
  const me = useMe()
  const { data: issues, isPending, isError, error, refetch } = useIssues()
  const chipFilter = useViewFilters()

  const items = useMemo(() => {
    const mine = MY_VERIFICATIONS_VIEW.pool(issues ?? [], { viewerLogin: me?.login })
    return chipFilter.apply(mine).sort((a, b) => a.createdAt.localeCompare(b.createdAt))
  }, [issues, me?.login, chipFilter])

  return (
    <div className="flex h-full flex-col">
      <ViewHeader
        title="My verifications"
        meta={`${items.length} open issue(s) you own the verification of`}
      />
      {isError ? (
        <ViewError what="issues" error={error} onRetry={() => refetch()} />
      ) : isPending ? (
        <TableSkeleton />
      ) : items.length === 0 ? (
        <EmptyState
          className="m-auto p-10"
          icon={<ShieldCheck className="text-faint-foreground size-6" />}
          title="Nothing assigned to you to verify"
        />
      ) : (
        <IssueTable issues={items} bulkKind="work" />
      )}
    </div>
  )
}
